var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-27ee3b53-0c43-47a7-a2c2-d9cfab4e3afa",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1440 1920",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .uuid-a4028cf4-d15b-42de-a7a5-67390a43efec {\r\n        fill: #2c2c2c;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uuid-a4028cf4-d15b-42de-a7a5-67390a43efec",
    d: "M1248,96c52.94,0,96,43.07,96,96v1536c0,52.93-43.06,96-96,96H192c-52.94,0-96-43.07-96-96V192c0-52.93,43.06-96,96-96h1056M1248,0H192C85.96,0,0,85.96,0,192v1536c0,106.04,85.96,192,192,192h1056c106.04,0,192-85.96,192-192V192c0-106.04-85.96-192-192-192h0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "uuid-a4028cf4-d15b-42de-a7a5-67390a43efec",
    d: "M708,639.84h-238.08v640.31h141.14v-235.22h80.62l119.06,235.22h159.33l-142.08-256.31c33.28-18.56,59.06-43.5,77.3-74.91,18.23-31.31,27.38-67.5,27.38-108.47,0-36.47-8.34-69.94-24.98-100.31-16.64-30.38-41.62-54.75-74.86-72.94-33.28-18.28-74.91-27.37-124.83-27.37h0ZM611.06,928.78v-169.87h89.25c26.25,0,47.2,7.69,62.91,22.97,15.66,15.37,23.53,36.19,23.53,62.44,0,24.38-7.69,44.53-23.06,60.47-15.38,16.03-36.47,24-63.37,24h-89.25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRIcon);
export default __webpack_public_path__ + "static/media/RIcon.d8c80eb5781d4291f0be49f4d1ad2500.svg";
export { ForwardRef as ReactComponent };